import React from 'react';


import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import ErrorIcon from '@mui/icons-material/Error';
import Grid from "@mui/material/Grid";

import Copyright from '../../components/Copyright';
import useStyles from '../../useStyles';



export default function NotFoundPage() {
    const classes = useStyles();

    return (
        <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
            <Grid container direction="row" alignItems="center">
                <Grid item xs={12}>
                    <ErrorIcon />
                </Grid>
                <Grid item xs={12}>
                    <Typography component="h1" variant="h5" color="#14143C">
                        404: Página Não Encontrada
                    </Typography>
                </Grid>
            </Grid>          

        </div>
        <Box mt={8}>
            <Copyright />
        </Box>
        </Container>
    );

}
